export default {
  title: 'Help and FAQs',
  buttons: {
    faqs: 'FAQS',
    contact_us: 'Contact us',
  },
};
